import { Block } from '@components/core-ui/Block';
import { startOfDay } from '@components/core-ui/form-elements/DatePicker/helpers/startOfDay';
import { TextDatePicker } from '@components/core-ui/form-elements/TextDatePicker';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import { useMemo } from 'react';

import { DatePickerWrapper } from './styles/DatePickerWrapper';

export const DeadlineBlock = () => {
  const { form, setFormItemValue } = usePageContext();
  const minDate = useMemo(() => startOfDay(), []);
  const maxDate = useMemo(() => {
    const date = startOfDay();
    date.setFullYear(date.getFullYear() + 1);
    return date;
  }, []);

  const handleDeadlineChange = (deadline: string) => {
    setFormItemValue('deadline', deadline || null);
  };

  return (
    <Block title="Deadline">
      <DatePickerWrapper>
        <TextDatePicker
          label="Deadline"
          dateFormat="MM/dd/yyyy"
          minDate={minDate}
          maxDate={maxDate}
          value={form.item?.deadline || undefined}
          onChange={handleDeadlineChange}
        />
      </DatePickerWrapper>
    </Block>
  );
};
